import type { DropdownProps } from 'react-day-picker';
import { useDayPicker } from 'react-day-picker';
import clsx from 'clsx';
import { useSelect } from 'downshift';

export const InputCalendarDropdownComponent = (props: DropdownProps) => {
  const { onChange, name, value, options } = props;
  const dayPicker = useDayPicker();

  const parsedOptions = (options ?? []).map((option) => ({ value: option.value, label: option.label }));

  const { isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps } = useSelect({
    items: parsedOptions,
    selectedItem: parsedOptions.find((item) => item.value === value),
    onSelectedItemChange: ({ selectedItem }) => {
      // @ts-expect-error
      return onChange?.({ target: { name, value: selectedItem.value } });
    },
  });

  return (
    <div>
      <div>
        <div
          className={clsx(dayPicker.classNames.caption_label, 'cursor-pointer')}
          style={dayPicker.styles?.caption_label ?? {}}
          {...getToggleButtonProps()}
        >
          <span>{parsedOptions.find((item) => item.value === value)?.label}</span>
          <span className="pl-2">{isOpen ? <>&#8593;</> : <>&#8595;</>}</span>
        </div>
      </div>
      <ul
        className={`text-info-500 absolute z-10 inline-block max-h-80 overflow-scroll rounded-lg bg-white p-0 text-sm font-light drop-shadow-xl ${
          !isOpen && 'hidden!'
        }`}
        style={dayPicker.styles?.dropdown ?? {}}
        {...getMenuProps()}
      >
        {isOpen &&
          parsedOptions?.map((item, index) => {
            return (
              <li
                className={clsx(
                  highlightedIndex === index && 'bg-info-100',
                  value === item.value && 'font-bold',
                  'flex cursor-default flex-col px-3 py-2 shadow-xs transition-colors',
                )}
                key={`${item.value}${index}`}
                {...getItemProps({ item, index })}
              >
                {item.label}
              </li>
            );
          })}
      </ul>
    </div>
  );
};
